import React, { useRef } from "react";
import styles from "./Home.module.sass";

import HeroBanner from "./HeroBanner";
import Condition from "./Condition";
import AppelAction from "../../components/AppelAction";

const Conditions = () => {

  return (
    <>
      <HeroBanner />
      <Condition />
      <AppelAction className="section-border-top" />
    </>
  );
};

export default Conditions;
